import React, { Component } from "react";
import { observer } from "mobx-react";
import OrderSearchLeftView from "../../../views/main/body/OrderSearchLeftView";
import OrderSearchTopView from "../../../views/main/body/OrderSearchTopView";
import OrderPagingBottomView from "../../../views/main/body/OrderPagingBottomView";
import OrderListTypeView from "../../../views/main/body/List/list/OrderListTypeView";
import OrderCardTypeView from "../../../views/main/body/List/card/OrderCardTypeView";
import OrderSearchNoDataView from "../../../views/main/body/OrderSearchNoDataView";
import OrderSearchAreaView from "../../../views/main/body/OrderSearchAreaView";
import { fn_setInitPage } from "../../../function/FnBodyOrder";

@observer
class MainBodyContainer extends Component {

    rootStore = this.props.rootStore;

    //interval;
    componentDidMount() {
        //주문 화면 page 초기화 처리.
        if (this.props.rootStore.searchStore.getShopCd != "" && this.props.rootStore.searchStore.getShopCd != null)
            fn_setInitPage(this.props.rootStore)
    }

    render() {

        const { rootStore } = this.props;

        let body_order_list;
        if (!rootStore.searchStore.getOrderSearchNoDataView) {
            if (rootStore.settingStore.getOrderViewType === "list") {
                body_order_list = <OrderListTypeView rootStore={rootStore} />
            } else if (rootStore.settingStore.getOrderViewType === "card") {
                body_order_list = <OrderCardTypeView rootStore={rootStore} />
            }
        } else {
            body_order_list = <OrderSearchNoDataView rootStore={rootStore} />
        }


        let list_top;
        if (rootStore.searchStore.getSearchBarBl) {
            list_top = <OrderSearchAreaView rootStore={rootStore} />
        }

        return (
            <>
                <div id="dummerContent">
                    <div className={(rootStore.viewStore.getDetailBaeminView ? ' bg layer_open' : '')}></div>
                    <OrderSearchLeftView rootStore={rootStore} />

                    <div id="leftContents">
                        <OrderSearchTopView rootStore={rootStore} />
                        {list_top}

                        {body_order_list}

                        <OrderPagingBottomView rootStore={rootStore} />
                    </div>
                </div>
            </>
        );
    }
}

export default MainBodyContainer;